// extracted by mini-css-extract-plugin
module.exports = {"th":"Thead_th__2u4a_","centered":"Thead_centered__2fGII","checkbox":"Thead_checkbox__2AXpQ"};